// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.theme--light.v-data-table .v-data-table-header th.sortable.accent.white--text .v-data-table-header__icon {\n    color: #fff !important;\n}\nspan.registeredTrademark {\n  position: relative;\n  top: -.3rem;\n  font-size: .5rem;\n  left: -0.05rem;\n}\nfooter {\n  font-size: small;\n}\n", ""]);
// Exports
module.exports = exports;
